(()=>{
 const mount=root=>{
  if(root.dataset.ucvReady)return;
  root.dataset.ucvReady='true';
  const rail=root.querySelector('.ucv__grid');
  const items=Array.from(root.querySelectorAll('.ucv__item'));
  const controls=Array.from(root.querySelectorAll('[data-ucv-position]'));
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const compact=matchMedia('(max-width:760px), (max-width:1023px) and (pointer:coarse)');
  const fine=matchMedia('(hover:hover) and (pointer:fine)');
  const abort=new AbortController();
  const on=(el,type,fn,passive=false)=>el.addEventListener(type,fn,{signal:abort.signal,passive});
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const cards=items.map(item=>{
   const link=item.querySelector('[data-ucv-capsule]');
   return {item,link,shape:link.querySelector('[data-ucv-shape]'),clip:link.querySelector('[data-ucv-clip]'),s:1,x:0,y:0,hx:0,hy:0,ts:1,tx:0,ty:0,thx:0,thy:0,width:164};
  });
  let active=-1,armed=-1,hover=-1,frame=0,last=0,stops=[],maxScroll=0,rtl=false,scrollFrame=0,resizeFrame=0;
  let pinned=false,storyHeight=0,storyTravel=0,storyTop=68,storyFrame=0,storyProgress=null,storyTime=0,storyWidth=innerWidth;
  const setActive=index=>{
   if(index===active)return;
   active=index;
   items.forEach((item,i)=>item.classList.toggle('is-active',i===index));
   controls.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
  };
  const draw=c=>{
   c.item.style.setProperty('--ucv-scale',c.s.toFixed(4));
   c.item.style.setProperty('--ucv-shift',c.x.toFixed(3)+'px');
   c.item.style.setProperty('--ucv-lift',c.y.toFixed(3)+'px');
   c.link.style.setProperty('--ucv-head-x',(c.hx*c.width/164).toFixed(3)+'px');
   c.link.style.setProperty('--ucv-head-y',(c.hy*c.width/164).toFixed(3)+'px');

  };
  const tick=time=>{
   const ease=reduced.matches?1:1-Math.exp(-Math.min(32,last?time-last:16.67)/105);
   last=time;let moving=false;
   cards.forEach(c=>{
    [['s','ts'],['x','tx'],['y','ty'],['hx','thx'],['hy','thy']].forEach(([v,t])=>{
     const delta=c[t]-c[v];
     if(Math.abs(delta)>(v==='s'?.0002:.015)){c[v]+=delta*ease;moving=true;}else c[v]=c[t];
    });
    draw(c);
   });
   if(moving&&!document.hidden)frame=requestAnimationFrame(tick);else{frame=0;last=0;}
  };
  const animate=()=>{if(!frame&&!document.hidden)frame=requestAnimationFrame(tick);};
  const focusAt=(position,desktop=false)=>{
   cards.forEach((c,i)=>{
    const distance=position<0?4:Math.abs(i-position);
    const weight=Math.max(0,1-distance);
    c.ts=reduced.matches?1:position<0?1:(desktop?.97:.96)+weight*(desktop?.06:.07);
    c.tx=reduced.matches||position<0?0:Math.sign(i-position)*Math.max(0,1-distance/2)*(desktop?8:5)*(rtl?-1:1);
    c.ty=reduced.matches?0:-weight*(desktop?8:5);
    c.thx=0;c.thy=reduced.matches?0:-weight*6;
   });
   setActive(position<0?-1:Math.round(position));
   animate();
  };
  const scrollPosition=()=>{
   const value=clamp(Math.abs(rail.scrollLeft),0,maxScroll);
   for(let i=0;i<stops.length-1;i++){
    if(value<=stops[i+1])return i+clamp((value-stops[i])/Math.max(1,stops[i+1]-stops[i]),0,1);
   }
   return Math.max(0,stops.length-1);
  };
  const measure=()=>{
   const shell=root.querySelector('.ucv__shell');
   storyTop=compact.matches?12:Math.ceil(document.querySelector('[data-ura-header]')?.getBoundingClientRect().height||68);
   storyHeight=Math.max(0,Math.floor((window.visualViewport?.height||innerHeight)-storyTop-(compact.matches?80:8)-(document.getElementById('PBarNextFrame')?76:0)));
   root.style.setProperty('--ucv-screen',storyHeight+'px');
   root.style.setProperty('--ucv-top',storyTop+'px');
   root.dataset.ucvStory='measuring';
   const heading=shell.querySelector('.ucv__heading'),navigation=shell.querySelector('.ucv__navigation');
   const overhead=heading.getBoundingClientRect().height+navigation.getBoundingClientRect().height+48;
   const canPin=!reduced.matches&&storyHeight>=360;
   const width=Math.max(44,Math.min(compact.matches?innerWidth*.68:260,canPin?(storyHeight-overhead)/2.7805/1.04:Infinity,compact.matches?300:(shell.clientWidth-120)/4/1.04));
   root.style.setProperty('--ucv-capsule-width',width+'px');
   pinned=canPin;
   root.dataset.ucvStory=pinned?'pinned':'static';
   storyTravel=pinned?storyHeight*(compact.matches?1.8:.8):0;root.style.height=pinned?(storyHeight+storyTravel)+'px':'';
   storyWidth=innerWidth;storyProgress=null;
   rtl=getComputedStyle(rail).direction==='rtl';
   maxScroll=rail.scrollWidth-rail.clientWidth;
   stops=items.map(item=>{
    const center=rtl?rail.clientWidth-item.offsetLeft-item.offsetWidth/2:item.offsetLeft+item.offsetWidth/2;
    return clamp(center-rail.clientWidth/2,0,maxScroll);
   });
   cards.forEach(c=>c.width=c.item.offsetWidth);
   if(pinned)queueStory();else focusAt(compact.matches?scrollPosition():hover,!compact.matches);
  };
  const paintStory=time=>{
   storyFrame=0;if(!pinned||document.hidden||!root.isConnected)return;
   const r=root.getBoundingClientRect();if(r.bottom<storyTop||r.top>innerHeight)return;
   const target=clamp((storyTop-r.top)/Math.max(1,storyTravel),0,1);
   const dt=Math.min(40,storyTime?time-storyTime:16.67);storyTime=time;
   if(storyProgress===null)storyProgress=target;else storyProgress+=(target-storyProgress)*(1-Math.exp(-dt/90));
   if(Math.abs(target-storyProgress)<.0001)storyProgress=target;
   const phase=clamp(storyProgress*4,0,4),i=Math.min(3,Math.floor(phase)),hold=compact.matches?.48:.40,blend=i===3?0:clamp((phase-i-hold)/(1-hold),0,1);
   root.style.setProperty('--ucv-progress',storyProgress.toFixed(4));
   const eased=compact.matches?blend*blend*blend*(blend*(blend*6-15)+10):blend*blend*(3-2*blend),focused=i+eased;
   if(compact.matches)rail.scrollLeft=(rtl?-1:1)*((stops[i]||0)+((stops[Math.min(3,i+1)]||0)-(stops[i]||0))*eased);
   focusAt(focused,!compact.matches);
   if(Math.abs(target-storyProgress)>.0001)queueStory();
  };
  const queueStory=()=>{if(!storyFrame)storyFrame=requestAnimationFrame(paintStory)};
  on(window,'scroll',queueStory,true);
  const select=(index,arm=false)=>{
   armed=arm?index:-1;
   focusAt(index,!compact.matches);
   if(pinned){window.scrollTo({top:scrollY+root.getBoundingClientRect().top-storyTop+storyTravel*((index+.275)/4),behavior:reduced.matches?'instant':'smooth'});return;}
   if(compact.matches)rail.scrollTo({left:(rtl?-1:1)*stops[index],behavior:reduced.matches?'instant':'smooth'});
  };
  controls.forEach((button,i)=>on(button,'click',()=>select(i,true)));
  cards.forEach((c,i)=>{
   on(c.link,'pointerenter',e=>{
    if(!fine.matches||e.pointerType==='touch')return;
    hover=i;focusAt(i,true);
   });
   on(c.link,'pointermove',e=>{
    if(!fine.matches||e.pointerType==='touch'||reduced.matches)return;
    const r=rail.getBoundingClientRect();
    const x=r.left+c.item.offsetLeft-rail.scrollLeft+c.item.offsetWidth/2;
    const y=r.top+c.item.offsetTop+c.item.offsetHeight/2;
    const dx=clamp((e.clientX-x)/(c.item.offsetWidth/2),-1,1);
    const dy=clamp((e.clientY-y)/(c.item.offsetHeight/2),-1,1);
    c.tx=dx*7;c.ty=-7+dy*4;c.thx=dx*2.5;c.thy=-6+dy*2;animate();
   },true);
   on(c.link,'focus',()=>{if(c.link.matches(':focus-visible'))select(i);});
   on(c.link,'click',e=>{
    if(e.detail===0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.target.closest('.ucv__head'))return;
    if(fine.matches||compact.matches)return;
    if(armed===i&&active===i)return;
    e.preventDefault();select(i,true);
   });
  });
  on(rail,'pointerleave',()=>{
   hover=-1;
   if(fine.matches&&!rail.contains(document.activeElement)){if(pinned)queueStory();else focusAt(compact.matches?scrollPosition():-1,!compact.matches);}
  });
  on(rail,'focusout',e=>{
   if(!rail.contains(e.relatedTarget)&&hover<0){if(pinned)queueStory();else focusAt(compact.matches?scrollPosition():-1,!compact.matches);}
  });
  on(rail,'scroll',()=>{
   if(pinned||!compact.matches||scrollFrame)return;
   scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;focusAt(scrollPosition());});
  },true);
  on(root,'keydown',e=>{
   const target=e.target.closest('[data-ucv-position],[data-ucv-capsule]');
   if(!target||!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
   e.preventDefault();
   const current=target.matches('[data-ucv-position]')?Number(target.dataset.ucvPosition):cards.findIndex(c=>c.link===target);
   let index=e.key==='Home'?0:e.key==='End'?cards.length-1:clamp(current+(e.key==='ArrowRight'?1:-1)*(rtl?-1:1),0,cards.length-1);
   select(index,true);controls[index].focus({preventScroll:true});
  });
  on(window,'resize',()=>{if(Math.abs(innerWidth-storyWidth)<2&&matchMedia('(pointer:coarse)').matches){queueStory();return;}if(!resizeFrame)resizeFrame=requestAnimationFrame(()=>{resizeFrame=0;measure();});},true);
  on(reduced,'change',measure);
  on(compact,'change',measure);
  on(document,'visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;last=0;}else measure();});
  on(document,'shopify:section:unload',e=>{
   if(!e.target.contains(root))return;
   cancelAnimationFrame(frame);cancelAnimationFrame(scrollFrame);cancelAnimationFrame(resizeFrame);cancelAnimationFrame(storyFrame);abort.abort();
  });
  measure();
 };
 const init=()=>document.querySelectorAll('[data-ura-capsule-motion]').forEach(mount);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
 document.addEventListener('shopify:section:load',init);
})();

